import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewBatchComp from "./Component/ViewBatchComp"


const ViewBatch =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewBatchComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewBatch